import React from 'react'
import { LogoProgress } from '../_controls'

const Suspense = ({ children, fallback = undefined }) => {
  return <React.Suspense fallback={fallback || <LogoProgress />}>{children}</React.Suspense>
}

export default Suspense
